import http from '@/assets/common/http';
// 获取套餐名称列表（分页）
export function queryPackageName(data) {
  const params = {
    SERVICE_ID: '10039',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取全部菜单(不分页)
export function queryAllPackageFun(data) {
  const params = {
    SERVICE_ID: '10039',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增套餐名称
export function addPackageFun(data) {
  const params = {
    SERVICE_ID: '10039',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除套餐名称
export function changePackageFun(data) {
  const params = {
    SERVICE_ID: '10039',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 匹配一个套餐
export function matchPackageFun(data) {
  const params = {
    SERVICE_ID: '10039',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询系统中全部套餐
export function searchAllPackageFun(data) {
  const params = {
    SERVICE_ID: '10039',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取就餐人数列表
export function queryMealCountFun(data) {
  const params = {
    SERVICE_ID: '12004',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增就餐人数配置
export function addMealCountFun(data) {
  const params = {
    SERVICE_ID: '12004',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改就餐人数配置
export function editMealCountFun(data) {
  const params = {
    SERVICE_ID: '12004',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增菜单
export function addPackageGroupFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取全部菜单(分页)
export function queryPackageGroupFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取全部菜单(不分页)
export function queryAllGroupFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改菜单信息
export function editPackageGroupFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除一个菜单
export function delPackageGroupFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取菜单匹配档口
export function queryMatchDKFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增菜单档口
export function addMatchDKFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增菜单档口
export function delMatchDKFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取未匹配的档口
export function selectDKFun(data) {
  const params = {
    SERVICE_ID: '12005',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取全部菜单
export function queryMenuFun(data) {
  const params = {
    SERVICE_ID: '12009',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增某天的菜单
export function addMenuFun(data) {
  const params = {
    SERVICE_ID: '12009',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改某个菜单的别名
export function editMenuFun(data) {
  const params = {
    SERVICE_ID: '12006',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除某一个菜单的别名
export function delMenuFun(data) {
  const params = {
    SERVICE_ID: '12006',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取菜单下配置的全部菜品
export function queryMatchDishesFun(data) {
  const params = {
    SERVICE_ID: '12009',
    OTYPE: 2,
    CKS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取所有成品菜
export function queryAllDishesFun(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 为菜单添加一个成品菜
export function addDishesFun(data) {
  const params = {
    SERVICE_ID: '12009',
    OTYPE: 1,
    CKS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 移除菜单中的某个菜品
export function delDishesFun(data) {
  const params = {
    SERVICE_ID: '12009',
    OTYPE: 3,
    CKS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取套餐对应的菜单
export function queryMatchGroupFun(data) {
  const params = {
    SERVICE_ID: '12006',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 为套餐添加一个分组
export function addMenuGroupFun(data) {
  const params = {
    SERVICE_ID: '12006',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除一个已匹配的分组
export function delMatchGroupFun(data) {
  const params = {
    SERVICE_ID: '12006',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增套餐订单
export function addPackageOrderFun(data) {
  const params = {
    SERVICE_ID: '12007',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取全部套餐订单
export function queryPackageOrderFun(data) {
  const params = {
    SERVICE_ID: '12007',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取某个客户日单
export function queryPackageOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '12007',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除某个客户日单
export function delOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '12007',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改某个日单
export function editPackageOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '12007',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 清空全部订单
export function delPackageOrderFun(data) {
  const params = {
    SERVICE_ID: '12007',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取菜单
export function queryMealGroupFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增菜单
export function addMealGroupFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除菜单
export function delMealGroupFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取全部套餐不分页
export function getAllPackageFun(data) {
  const params = {
    SERVICE_ID: '12009',
    OTYPE: 4,
    CKS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取菜单每天的套餐
export function getPackageGroupDetailFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 提交菜单每天的套餐配置
export function addMatchPackageFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 匹配客户
export function addMatchSchoolFun(data) {
  const params = {
    SERVICE_ID: '12010',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取全部客户
export function getAllSchoolFun(data) {
  const params = {
    SERVICE_ID: '12010',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取已经匹配的客户
export function getMatchSchoolFun(data) {
  const params = {
    SERVICE_ID: '12010',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 解除匹配
export function delMatchSchoolFun(data) {
  const params = {
    SERVICE_ID: '12010',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 转换订单
export function transferOrderFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取所有餐别
export function getAllMealFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 菜单增加一个餐别
export function matchMealFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 菜单删除一个餐别
export function deleteMatchedMealFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取菜单已匹配的餐别
export function getMatchedMealFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 给菜单增加一个套餐
export function MatchPackageFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 菜单删除一个套餐
export function deleteMatchedPackageFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 按日期、餐别查询菜单的所有套餐
export function getRecipeDetailFun(data) {
  const params = {
    SERVICE_ID: '12008',
    OTYPE: 13,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/packageManage.js